document.addEventListener('click', function (event) {
  const btn = event.target.closest('[data-color-pack-option]');
  if (!btn) return;

  const swatchType = btn.dataset.swatchType;

  if (swatchType === 'preset') {
    if (btn.dataset.url) window.location.href = btn.dataset.url;
    return;
  }

  if (swatchType === 'link') {
    if (btn.dataset.linkUrl) window.location.href = btn.dataset.linkUrl;
    return;
  }

  const group = btn.closest('[data-color-pack-group]');
  if (!group) return;

  group.querySelectorAll('[data-color-pack-option]').forEach(function (el) {
    el.classList.remove('color-pack-option--active');
  });
  btn.classList.add('color-pack-option--active');

  document.dispatchEvent(new CustomEvent('color-pack:change', {
    detail: {
      swatchType: swatchType,
      element: btn
    }
  }));
});

function updatePresetGroups(packKey) {
  if (!packKey) return;
  const keyStr = String(packKey).toLowerCase().trim();

  document.querySelectorAll('[data-preset-group]').forEach(function (el) {
    const elKey = String(el.dataset.packKey || '').toLowerCase().trim();
    if (elKey === keyStr) {
      el.removeAttribute('hidden');
    } else {
      el.setAttribute('hidden', 'hidden');
    }
  });

  // Custom Pack Option Button (First card e.g. "Custom Pack")
  const customPackOptionBtn = document.querySelector('[data-color-pack-option][data-swatch-type="custom_pack"]');

  // Custom Pack Builder Grid (The + slots)
  const customPackBuilder = document.querySelector('[data-custom-pack-builder]');

  if (keyStr === 'singles') {
    if (customPackOptionBtn) customPackOptionBtn.style.display = 'none';
    if (customPackBuilder) {
      customPackBuilder.hidden = true;
      customPackBuilder.style.display = 'none';
    }
  } else {
    if (customPackOptionBtn) customPackOptionBtn.style.display = '';
  }
}

// Event listener for pack change
document.addEventListener('pack:change', function (event) {
  const packKey = event.detail ? (event.detail.packKey || event.detail.quantity) : null;
  if (packKey) {
    updatePresetGroups(packKey);
  }
});